import React from 'react';
import { Controller, FieldError } from 'react-hook-form';

interface FormTextareaProps {
  name: string;
  control: any;
  label: string;
  required?: boolean;
  disabled?: boolean;
  maxLength: number;
  characterCount: number;
  className?: string;
  row?: number;
}

const FormTextarea: React.FC<FormTextareaProps> = ({
  name,
  control,
  label,
  required,
  disabled,
  maxLength,
  characterCount,
  className = '',
  row = 3
}) => {
  const remainingChars = Math.max(0, maxLength - characterCount);

  return (
    <div>
      <label className='block text-sm font-medium text-slate-700 mb-1'>
        {label} {required && <span className='text-red-500'>*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field, formState: { errors } }) => {
          const error = errors[name] as FieldError | undefined;
          return (
            <>
              <textarea
                {...field}
                value={field.value || ''}
                onChange={e => {
                  field.onChange(e.target.value);
                  field.onBlur();
                }}
                className={`border rounded px-2 py-1.5 w-full focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  error ? 'border-red-500' : 'border-gray-300'
                } ${className}`}
                rows={row}
                maxLength={maxLength}
                placeholder={`Enter ${label.toLowerCase()} here...`}
                disabled={disabled}
              />
              <div className='text-xs text-gray-600 mt-1 text-right'>
                {remainingChars} Character(s) Remaining ({characterCount}/
                {maxLength})
              </div>
              {error && (
                <p className='text-red-500 text-xs mt-1'>{error.message}</p>
              )}
            </>
          );
        }}
      />
    </div>
  );
};

export default FormTextarea;
